<!-- select.component.html -->
<div class="select selectRes"
  [ngClass]="{'focus': focus, 'error': msgError!=null && msgError!='', 'readonly':readonly, 'blue' : isBlue, 'white_background': white_background }">
  <input #select type="text" (focus)="focusEv()" (focusout)="focusoutEv()"
    [ngClass]="{'full': value, 'blue' : isBlue, 'remove-all-styles' : readonly }"
    [(ngModel)]="inputValue" (input)="!modalSelector && filter($event)"
    class="selectRes" [readonly]="readonly || modalSelector" [disabled]="disabled" />
  <label [ngClass]="{ 'label color' : isBlue }">{{label}}</label>
  <span id="msgError" [ngClass]="{'fixBottom': fixBottom }">{{msgError}}</span>
  <i [ngClass]="(focus?'fa fa-chevron-up':'fa fa-chevron-down') + ' ' + (isBlue ? 'color' : '')"
    (click)="toggleListDisplay()"></i>

  <div class="data selectRes" *ngIf="(display || dataShow) && !modalSelector">
    <ul class="selectRes">
      <li class="item" *ngFor="let item of result" (click)="selectItem(item)">
        {{ (listDisplay ? item[listDisplay] : item)?.toString() | titlecase }}
      </li>
    </ul>
  </div>
</div>

<div class="modal-overlay" *ngIf="modalVisible">
	<div class="modal-card">
		<img src="assets/images/icons/close-circle-icon.png" class="modal-close" alt="" srcset="" (click)="closeAdvancedSelector()" />
		<h3 class="modal-title">Selecciona las presentaciones del producto requeridas</h3>
		<ul class="modal-options">
			<li *ngFor="let item of result" (click)="selectItemFromModal(item)">
				<span>{{ (listDisplay ? item[listDisplay] : item)?.toString() | titlecase }}</span>
				<input
					type="radio"
					name="presentationModal"
					[checked]="value && (listDisplay ? value[listDisplay] : value) === (listDisplay ? item[listDisplay] : item)"
				/>
			</li>
		</ul>
	</div>
</div>
